<!--
 * @Description: 教职工详情 国内进修学习
 * @Author: 张天伟
 * @Date: 2023-03-08 17:08:46
 * @LastEditors: PF
 * @LastEditTime: 2023-03-10 16:19:56
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="进修性质" label-align="right" align="left" width="120px" span="2">{{item.jxxzbt}}</el-descriptions-item>
        <el-descriptions-item label="学习方式" label-align="right" align="left" width="120px" span="2">{{item.xxfsbt}}</el-descriptions-item>
        <el-descriptions-item label="学习起止年月" label-align="right" align="left" width="120px" span="2">{{item.xxqsny}}</el-descriptions-item>
        <el-descriptions-item label="学习终止年月" label-align="right" align="left" width="120px" span="2">{{item.xxzzny}}</el-descriptions-item>
        <el-descriptions-item label="总学时" label-align="right" align="left" width="120px" span="2">{{item.zxs}}</el-descriptions-item>
        <el-descriptions-item label="学习内容" label-align="right" align="left" width="120px" span="2">{{item.xxnr}}</el-descriptions-item>
        <el-descriptions-item label="进修班名称" label-align="right" align="left" width="120px" span="2">{{item.jxbmc}}</el-descriptions-item>
        <el-descriptions-item label="主办单位" label-align="right" align="left" width="120px" span="2">{{item.zbdw}}</el-descriptions-item>
        <el-descriptions-item label="主办单位性质" label-align="right" align="left" width="120px" span="2">{{item.zbdwxzbt}}</el-descriptions-item>
        <el-descriptions-item label="在学单位" label-align="right" align="left" width="120px" span="2">{{item.zxdw}}</el-descriptions-item>
        <el-descriptions-item label="在学单位类别" label-align="right" align="left" width="120px" span="2">{{item.zxdwlbbt}}</el-descriptions-item>
        <el-descriptions-item label="进修结果" label-align="right" align="left" width="120px" span="2">{{item.jxjgbt}}</el-descriptions-item>
      </el-descriptions>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongguoneijinxiouxuexi/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
